// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__122HX","inner":"Form_inner__cXvz-","range":"Form_range__39AI5","name":"Form_name__2-ReZ","actions":"Form_actions__yRxZc"};